const debounce = (func, delay, isDeferred = false) => {
    let isDebounced = false;

    const wrapper = () => {
        if (isDebounced) {
            return;
        }

        isDebounced = true;

        if (!isDeferred) {
            func();
        }

        setTimeout(() => {
            isDebounced = false;
            if (isDeferred) {
                func();
            }
        }, delay);
    };

    return wrapper;
};

export default debounce;
